import CryptoJS from "crypto-js";

// Função para gerar uma nova chave criptográfica
function gerarChave() {
  return CryptoJS.lib.WordArray.random(32).toString(CryptoJS.enc.Hex);
}

// Função para criptografar dados
function criptografarDados(key, data) {
  const iv = CryptoJS.lib.WordArray.random(16);
  const encrypted = CryptoJS.AES.encrypt(data, CryptoJS.enc.Hex.parse(key), {
    iv: iv,
  });
  return {
    iv: iv.toString(CryptoJS.enc.Base64),
    data: encrypted.toString(),
  };
}

// Função para descriptografar dados
function descriptografarDados(key, iv, data) {
  const decrypted = CryptoJS.AES.decrypt(data, CryptoJS.enc.Hex.parse(key), {
    iv: CryptoJS.enc.Base64.parse(iv),
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}

// Função para criptografar e armazenar um objeto no Session Storage
export async function criptografarObjetoSession(key, obj) {
  const rawKey = gerarChave();
  const encrypted = criptografarDados(rawKey, JSON.stringify(obj));

  sessionStorage.setItem(
    key,
    JSON.stringify({
      iv: encrypted.iv,
      data: encrypted.data,
      metaInfo: rawKey,
    })
  );
}

// Função para recuperar e descriptografar um valor específico de um objeto armazenado no Session Storage
export async function descriptografarObjetoSession(key, subKey) {
  const item = sessionStorage.getItem(key);
  if (!item) return null;

  const { iv, data, metaInfo } = JSON.parse(item);
  const decrypted = descriptografarDados(metaInfo, iv, data);
  const obj = JSON.parse(decrypted);

  return obj[subKey];
}
